import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import style from '../ProductPrice.module.scss.js';

const Nowrap = ({ className, ...otherProps }) => (jsx("div", { ...otherProps, className: classNames(className, style['z-product-price__nowrap']) }));
Nowrap.displayName = 'Nowrap';

export { Nowrap };
//# sourceMappingURL=Nowrap.js.map
